<template>
  <Panel class="">
    <template #icon>
      <i class="fa fa-trophy"></i>
    </template>

    <template #title>
      Perfil geral dos pacientes
    </template>

    <div v-if="patients_more_appointments.length === 0 && loading == false && loaded == true" class="tw-text-center">
      <p class="tw-font-semibold  tw-text-xl">
        Sem dados suficientes para exibir o gráfico.
      </p>
      <small>Cadastre a origem de alguns pacientes depois volte aqui :)</small>
    </div>
    <div class="tw-relative" style="min-height: 500px" v-if="loading">
      <img v-bind:src="loadingImage" class="tw-absolute tw-right-1/2 tw-translate-x-1/2 tw-top-1/2 tw-translate-y-1/2 tw-z-10" >
    </div>
    <div  v-show="!loading">
      <div class="tw-flex tw-flex-col md:tw-flex-row md:tw-space-x-8" >
        <div class="md:tw-w-6/12">
          <div class="tw-overflow-hidden tw-shadow tw-ring-1 tw-ring-black tw-ring-opacity-5 md:tw-rounded-lg">
            <table class="tw-min-w-full tw-divide-y tw-divide-gray-300 striped-table">
              <thead class="">
                <tr>
                  <th scope="col" colspan="2" class="tw-py-2 tw-pl-4 tw-pr-3 tw-text-left tw-text-sm tw-font-semibold tw-text-gray-900 sm:tw-pl-6">
                    Pacientes com mais consultas realizadas
                  </th>
                </tr>
              </thead>
              <tbody class="tw-bg-white">
                <tr v-for="patient in patients_more_appointments" :key="patient.id" class="">
                    <td class="tw-whitespace-nowrap tw-py-2 tw-pl-4 tw-pr-3 tw-text-sm tw-font-medium tw-text-gray-900 sm:tw-pl-6">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="tw-w-4 tw-h-4 tw-inline">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0" />
                      </svg>
                      <a :href="`/patients/${patient.id}`">
                        {{patient.full_name}}
                      </a>
                    </td>
                    <td class="tw-whitespace-nowrap tw-px-3 tw-py-2 tw-text-sm tw-text-gray-800 tw-text-right">
                      {{patient.appointments_count}}
                    </td>
                </tr>
              </tbody>
            </table>
          </div>
          <small class="tw-text-gray-600">* Nos últimos 12 meses</small>
        </div>
        <div class="md:tw-w-6/12 tw-flex tw-flex-col tw-min-h-62.5" >
          <div class="tw-w-full tw-flex-1 tw-items-center tw-flex tw-shadow tw-ring-1 tw-ring-black tw-ring-opacity-5 md:tw-rounded-lg">
            <pie-chart
              class="pie-chart tw-h-62.5 tw-w-147 tw-min-w-125"
              :chart-data="genderCharts"
              chartRadius="80%"/>
          </div>
          <small class="tw-text-gray-600">* Toda a base de pacientes com gênero cadastrado</small>
        </div>
      </div>
      <div class="md:tw-w-full" >
        <h3 class="tw-font-bold tw-text-lg tw-mt-16">Idade dos pacientes</h3>
        <stacked-bar-chart class="tw-mt-4 tw-h-125" :chart-data="ages"/>
      </div>
    </div>
  </Panel>
</template>
<script>
import axios from "axios";
import PieChart from '../charts/pie-chart.vue'
import PeriodSelector from "../form/period-selector"
import loadingImage from 'images/spinner.svg';
import Panel from "../panel"
import StackedBarChart from "../charts/stacked-bar-chart";

export default {
  props: {
    companyCreatedAt: String,
  },
  components: {
    StackedBarChart,
    PeriodSelector,
    PieChart,
    Panel
  },
  data() {
    return {
      loadingImage,
      loaded: false,
      loading: false,
      genderCharts: [],
      patients_more_appointments: [],
      ages: {}
    };
  },
  computed: {
    femalePercent(){
      return this.female == 0 ? 0 : (this.female/(this.male+this.female)*100)
    },
    malePercent(){
      return this.male == 0 ? 0 : (this.male/(this.male+this.female)*100)
    }
  },
  mounted() {
    setTimeout(() => this.fetch(), 500)
  },
  methods: {
    fetch() {
      this.loaded = true
      this.loading = true

      axios
        .get(
          '/insights/patients_overview'
        )
        .then(response => {
          this.genderCharts = [
            {value: response.data.data.male, name: "Masculino"}, {value: response.data.data.female,  name: "Feminino"},
          ]
          this.patients_more_appointments = response.data.data.patients_more_appointments
          this.ages = response.data.data.ages
          this.ages.series = this.ages.series.map(serie => {
            return {
              data: serie,
            }
          })
          this.loading = false
        });
    }
  }
};
</script>
